<template src="../templates/normal_fcont_15.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import PrintButton from '../components/PrintButton'
import UseDesignPaperList from '../components/UseDesignPaperList'

import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative'
export default {
  name: 'app',
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,FuncSearchGalleryQR,
   PrintButton,UseDesignPaperList,AppDownloadCreative
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['15-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['15-2']}
    ]};
  }
};
</script>
<style />


